var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPromptMainIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 4.6665H7.33325",
    stroke: "#2D323E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 11.3335H3.33325",
    stroke: "#2D323E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 13.3335C12.4378 13.3335 13.3333 12.4381 13.3333 11.3335C13.3333 10.2289 12.4378 9.3335 11.3333 9.3335C10.2287 9.3335 9.33325 10.2289 9.33325 11.3335C9.33325 12.4381 10.2287 13.3335 11.3333 13.3335Z",
    stroke: "#2D323E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 6.6665C5.77132 6.6665 6.66675 5.77107 6.66675 4.6665C6.66675 3.56193 5.77132 2.6665 4.66675 2.6665C3.56218 2.6665 2.66675 3.56193 2.66675 4.6665C2.66675 5.77107 3.56218 6.6665 4.66675 6.6665Z",
    stroke: "#2D323E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPromptMainIcon);
export default __webpack_public_path__ + "static/media/edit-prompt-main-icon.b5b253911ca8cba5e592dfdccdb47606.svg";
export { ForwardRef as ReactComponent };